module.exports = __webpack_public_path__ + "img/mikmic-1-christmas.6b2dfa85.png";